import React, { useEffect, useRef, useState } from "react";
import ReactMarkdown from "react-markdown";
import remarkGfm from "remark-gfm";

const TypedMessage = ({ content, children }) => {
  const [displayedContent, setDisplayedContent] = useState("");
  const contentRef = useRef(content);

  useEffect(() => {
    contentRef.current = content;
    setDisplayedContent("");

    let index = 0;
    const timer = setInterval(() => {
      if (index >= contentRef.current.length) {
        clearInterval(timer);
        return;
      }

      index++;
      setDisplayedContent(contentRef.current.slice(0, index));
    }, 30);

    return () => clearInterval(timer);
  }, [content]);

  return children ? children(displayedContent) : <div>{displayedContent}</div>;
};

export default function MessageContent({ content, type }) {
  if (type === "bot") {
    return (
      <TypedMessage content={content}>
        {(displayedContent) => (
          <div className="prose prose-sm max-w-none">
            <ReactMarkdown
              remarkPlugins={[remarkGfm]}
              components={{
                pre: ({ node, ...props }) => (
                  <pre className="bg-gray-100 p-2 rounded" {...props} />
                ),
                code: ({ node, inline, ...props }) => (
                  <code
                    className={inline ? "bg-gray-100 rounded px-1" : "block"}
                    {...props}
                  />
                ),
                p: ({ node, ...props }) => <p className="mb-4" {...props} />,
                ul: ({ node, ...props }) => (
                  <ul className="list-disc pl-4 mb-4" {...props} />
                ),
                ol: ({ node, ...props }) => (
                  <ol className="list-decimal pl-4 mb-4" {...props} />
                ),
                li: ({ node, ...props }) => <li className="mb-1" {...props} />,
                h1: ({ node, ...props }) => (
                  <h1 className="text-2xl font-bold mb-4" {...props} />
                ),
                h2: ({ node, ...props }) => (
                  <h2 className="text-xl font-bold mb-3" {...props} />
                ),
                h3: ({ node, ...props }) => (
                  <h3 className="text-lg font-bold mb-2" {...props} />
                ),
                a: ({ node, href, ...props }) => {
                  const safeHref = href && href.startsWith("http") ? href : "#";
                  return (
                    <a
                      href={safeHref}
                      className="text-blue-900 hover:underline"
                      target="_blank"
                      rel="noopener noreferrer"
                      {...props}
                    />
                  );
                },
                table: ({ node, ...props }) => (
                  <table
                    className="table-auto border border-collapse border-gray-300 my-4"
                    {...props}
                  />
                ),
                thead: ({ node, ...props }) => (
                  <thead className="bg-gray-100" {...props} />
                ),
                th: ({ node, ...props }) => (
                  <th
                    className="border px-2 py-1 text-left font-semibold"
                    {...props}
                  />
                ),
                td: ({ node, ...props }) => (
                  <td className="border px-2 py-1" {...props} />
                ),
              }}
            >
              {displayedContent}
            </ReactMarkdown>
          </div>
        )}
      </TypedMessage>
    );
  }
  return <div>{content}</div>;
}
